import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import { notification } from '@iso/components';
import MasterApi from '@iso/lib/api/masterHelper';
import actions from './actions';

export function* masterCreateRequest() {
  yield takeEvery(actions.MASTER_ADD_NEW, function* ({ payload }) {
    console.log("payloaddddd",payload);
    const result = yield call(MasterApi.create, payload.dataObj);
    console.log("resulttttttpayload",result);
    if (result.status === 0) {
      notification('error', result.message);
    } else {
      console.log("payload.dataObj","200");
      notification('success', result.message);
      yield put({
        type: actions.MASTER_READ,
        success: true,
        msg: result.message,
      });
      window.location.reload(true)
      // payload.history.push('/dashboard/listMaster');
    }
  });
}

export function* masterReadRequest() {

  yield takeEvery(actions.MASTER_READ, function* ({ payload }) {
    console.log("payloadddddRead",payload);
    try {
      const searchResult = yield call(MasterApi.read, payload.readFilter, payload.page);
      console.log("payloadddddsearchResult",searchResult);
      if (searchResult.status) {
        yield put(
          actions.masterReadSearchSuccess(
            searchResult.result,
            true,
            searchResult.totalRecordCount,
            payload.page,
            payload.readFilter
          )
        );
      } else {
        notification('error', searchResult.message);
        yield put(
          actions.masterReadSearchSuccess([],false,0,0,{})
        );
      }
    } catch (error) {
      console.log("Error::::::::::::::", error);
      //  yield put(actions.gitSearchSuccess());
    }
  })
}


/*****fetch record by id *************/
export function* masterFindByIdRequest() {
  yield takeEvery(actions.MASTER_FIND_BY_ID, function* ({ payload }) {
    try {
      const result = yield call(MasterApi.findById, payload.masterId);
      if (result.success) {
        notification('success', result.message);
        yield put({
          type: actions.MASTER_ITEM_SUCCESS,
          result: result.data,
          success: result.success
        });
      } else {
        notification('error', result.message);
      }
    } catch (error) {
    }
  });
}


export default function* rootSaga() {
  yield all([
    fork(masterCreateRequest),
    fork(masterReadRequest),
  ]);
}
